<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box1">
      <div class="main">
        <div class="xw-title">{{ $t('hyxw.text1') }}</div>
        <div class="xw-grid">
          <div class="grid-item" v-for="(item,index) in $t('hyxw.list')" :key="index">
            <div class="item-name">{{item.title}}</div>
            <div class="item-time">{{item.time}}</div>
            <img class="item-img" :src="item.img">
            <div class="item-text">{{item.text}}</div>
            <div style="flex: 1"></div>
            <div class="item-look">{{ $t('hyxw.text2') }}</div>
          </div>
        </div>
        <div class="al-page">
          <div class="page-item " v-for="(item,i) in 3" :key="i" :class="0===i? 'item2':''">
            {{i+1}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.template-container {
  position: relative;
  width: 100%;

  .main {
    width: 1280px;
  }

  .main-box1 {
    width: 100%;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/hyxw/xw_bg1.png");
    .xw-title{
      margin-top: 120px;
      margin-bottom: 70px;
      text-align: center;
      font-size: 36px;
      font-weight: 500;
      color: #111111;
    }
    .xw-grid{
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 20px;
      row-gap: 20px;
      .grid-item{
        display: flex;
        flex-direction: column;
        padding: 30px;
        height: 668px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-sizing: border-box;
        border: 1px solid #FFFFFF;
        .item-name{
          height: 64px;
          font-size: 22px;
          font-weight: 600;
          line-height: 32px;
          color: #1C1C1C;
        }
        .item-time{
          text-align: end;
          font-size: 14px;
          font-weight: 600;
          color: #939393;
        }
        .item-text{
          font-size: 14px;
          font-weight: 600;
          line-height: 24px;
          color: #888888;
        }
        .item-img{
          margin-top: 12px;
          margin-bottom: 36px;
          object-fit: cover;
          height: 330px;
          color: #1C1C1C;
        }
        .item-look{
          cursor: pointer;
          text-align: end;
          font-size: 14px;
          font-weight: 600;
          color: #3D3D3D;
        }
      }
    }
    .al-page{
      display: flex;
      justify-content: center;
      .page-item{
        background: #fff;
        cursor: pointer;
        text-align: center;
        margin-top: 50px;
        margin-bottom: 92px;
        margin-right: 5px;
        width: 48px;
        height: 48px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 600;
        line-height: 46px;
        border: 1px solid #fff;
      }
      .item2{
        border: 1px solid #1F65FE;
        color: #1F65FE;
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    position: relative;
    width: 100%;

    .main {
      width: 100%;
    }

    .main-box1 {
      width: 100%;
      display: flex;
      justify-content: center;
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/hyxw/xw_bg1.png");
      .xw-title{
        margin-top: 120px;
        margin-bottom: 70px;
        text-align: center;
        font-size: 36px;
        font-weight: 500;
        color: #111111;
      }
      .xw-grid{
        display: grid;
        grid-template-columns: 1fr ;
        column-gap: 20px;
        row-gap: 20px;
        .grid-item{
          display: flex;
          flex-direction: column;
          padding: 20px;
          height: 668px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 10px;
          box-sizing: border-box;
          border: 1px solid #FFFFFF;
          .item-name{
            height: 64px;
            font-size: 22px;
            font-weight: 600;
            line-height: 32px;
            color: #1C1C1C;
          }
          .item-time{
            text-align: end;
            font-size: 14px;
            font-weight: 600;
            color: #939393;
          }
          .item-text{
            font-size: 14px;
            font-weight: 600;
            line-height: 24px;
            color: #888888;
          }
          .item-img{
            margin-top: 12px;
            margin-bottom: 36px;
            object-fit: cover;
            width: 100%;
            height: 250px;
            color: #1C1C1C;
          }
          .item-look{
            cursor: pointer;
            text-align: end;
            font-size: 14px;
            font-weight: 600;
            color: #3D3D3D;
          }
        }
      }
      .al-page{
        display: flex;
        justify-content: center;
        .page-item{
          background: #fff;
          cursor: pointer;
          text-align: center;
          margin-top: 50px;
          margin-bottom: 92px;
          margin-right: 5px;
          width: 48px;
          height: 48px;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 600;
          line-height: 46px;
          border: 1px solid #fff;
        }
        .item2{
          border: 1px solid #1F65FE;
          color: #1F65FE;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hyxw/index.vue